import resiOptions from './resiOptions'

export default {
    resiOptions,
}